import React from 'react';

/**
 * @param {object} props
 * @return {*}
 * @constructor
 */
const Card = ({ children, className }) => (
    <div className={`shadow bg-white ${className}`}>
        {children}
    </div>
);

export default Card;
